/**
 * Shared constants for child type calculations to avoid duplication
 */

export const CHILD_TYPE_ARRAY = ['board', 'card', 'file', 'document'] as const;

export type ChildType = typeof CHILD_TYPE_ARRAY[number];